import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap"; // Import React-Bootstrap
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import { FaRing, FaUser } from "react-icons/fa";

const ownerMaritalStatus = [
  {
    label: "Célibataire",
    value: "single",
    icon: <FaUser size={50} style={{ margin: "15px auto" }} color="#051259" />,
  },
  {
    label: "Marié(e)",
    value: "married",
    icon: <FaRing size={50} style={{ margin: "15px auto" }} color="#051259" />,
  },
];

function OwnerMaritalStatus() {
  const navigate = useNavigate();
  const currentStep = "Propriétaire";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  const handleMaritalStatusSelect = async (maritalStatus) => {
    await dispatch(
      addToCart({
        maritalStatus: maritalStatus,
      }),
    );
    navigate("/procedure");
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        paddingBottom: "40px",
        position: "relative",
      }}
    >
      <Header />

      <ProgressBar steps={steps} currentStep={currentStep} />

      <Container className="mt-4 text-center">
        {cart.ownerType === "myself" ? (
          <h4 className="text-2xl font-semibold">
            Quel est votre
            <span style={{ color: "#FF5500" }}>statut matrimonial</span> ?
          </h4>
        ) : (
          <h4 className="text-2xl font-semibold">
            Quel est votre{" "}
            <span style={{ color: "#FF5500" }}>statut matrimonial</span> ?
          </h4>
        )}
      </Container>

      <Container className="mt-4 d-flex justify-content-center">
        <Row className="w-100" style={{ maxWidth: "900px" }}>
          {ownerMaritalStatus.map((status, index) => (
            <Col
              xs={12}
              md={6}
              lg={6}
              className="mb-4 d-flex justify-content-center"
              key={index}
            >
              <div
                className="ownertype-box"
                onClick={() => handleMaritalStatusSelect(status.value)}
                style={{
                  width: "80%",
                  minHeight: "140px",
                  border: `2px solid ${cart.maritalStatus === status.value ? "#FF5500" : "#ddd"}`,
                  borderRadius: "8px",
                  padding: "15px",
                  cursor: "pointer",
                  transition: "border-color 0.3s",
                  textAlign: "center",
                  color: "#000",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.borderColor = "#FF5500")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.borderColor =
                    cart.maritalStatus === status.value ? "#FF5500" : "#ddd")
                }
              >
                <div>{status.icon}</div>
                <span style={{ fontSize: "1rem" }}>{status.label}</span>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
}

export default OwnerMaritalStatus;
